import Card from 'features/shared/components/card/Card';
import InfoItem from 'features/shared/components/infoItem/InfoItem';
import { formatDate, formatPrice } from 'features/shared/helpers/Formatters';
import React from 'react';
import { useTranslation } from 'react-i18next';
import PaymentDTO from '../dtos/PaymentDTO';

interface Props {
  payment: PaymentDTO;
}

const PaymentInfoCard = ({ payment }: Props) => {
  // translations
  const tTypes = useTranslation("payments\\enums\\paymentType").t;
  const tLabels = useTranslation("payments\\payments").t;

  // variables
  const totalUsageAmount = payment.paymentUsage?.map(item => item.amount!).reduce((prev, next) => prev + next);;

  // helpers
  const getPaymentState = ():string => {
    if (payment.amount === totalUsageAmount) {
      return tLabels("paymentInfoCard.completelyUsed");
    } else if (payment.amount !== totalUsageAmount) {
      return tLabels("paymentInfoCard.partiallyUsed");
    } else if (totalUsageAmount === 0) {
      return tLabels("paymentInfoCard.notUsed");
    }

    return "";
  }
  
  // render
  return (
    <Card className="pt-3 px-3 pb-1">
      <div className="row no-gutters">
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("paymentInfoCard.paymentDate")} value={formatDate(payment.paymentDate!)} icon="calendar-alt" />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("paymentInfoCard.paymentType")} value={tTypes(`${payment.paymentType}.full`)} icon="swatchbook"  />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("paymentInfoCard.paymentState")} value={getPaymentState()} icon="tag" />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("paymentInfoCard.amount")} value={formatPrice(payment.amount!, payment.currency!, 2)} icon="money-bill-alt" />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("paymentInfoCard.usageAmount")} value={formatPrice(totalUsageAmount!, payment.currency!, 2)} icon="money-bill" />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("paymentInfoCard.variableSymbol")} value={payment.variableSymbol} icon="flag"  />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("paymentInfoCard.accountCustomer")} value={payment.accountCustomer ?? "-"} icon="university" />
        </div>
        <div className="col-sm-6 col-lg-8 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("paymentInfoCard.messageForRecipient")} value={payment.messageForRecipient || "-"} icon="comment" />
        </div>
      </div>
    </Card>
  )
}

export default PaymentInfoCard;
